export default __webpack_public_path__ + "static/simple-bar-514a13e7561c943ec94a5b0c2643c4bb.png";